var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _polygon, _path, _polygon2, _polygon3, _path2, _path3, _polygon4, _path4, _path5, _path6, _path7, _path8, _polygon5, _path9, _polygon6, _path0, _path1, _path10, _polygon7, _path11, _path12, _path13, _path14, _path15, _circle, _path16, _polygon8, _path17, _polygon9, _path18, _rect6, _g, _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistroCenfotec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 709.34 497.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d1d4d4;}.cls-2{fill:#dbf2fc;}.cls-3{fill:#00479b;}.cls-4{fill:#9cc8ff;}.cls-5{fill:#006aea;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:url(#radial-gradient);}.cls-13,.cls-14{stroke:#abd5ef;}.cls-13,.cls-14,.cls-21,.cls-22{stroke-miterlimit:10;}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-8);}.cls-15{fill:url(#linear-gradient-9);}.cls-16{fill:url(#linear-gradient-10);}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:url(#linear-gradient-12);}.cls-19{fill:#deb87d;}.cls-20{fill:url(#linear-gradient-13);}.cls-21,.cls-22{stroke:#ffe28e;}.cls-21{fill:url(#radial-gradient-2);}.cls-22{fill:url(#radial-gradient-3);}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:url(#linear-gradient-17);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -147.7,
    y1: 265.19,
    x2: -111.01,
    y2: 328.75,
    gradientTransform: "matrix(-1, 0, 0, 1, 366.45, -127.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#a1cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#afd3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c6e0fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#e5f3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebf6fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 837.54,
    y1: 254.54,
    x2: 786.31,
    y2: 343.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61c1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#77c7ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8ecded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9ed2ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#a8d4ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#abd5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#e6f3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebf6fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -263.98,
    y1: 256.51,
    x2: 31.79,
    y2: 256.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 366.45, -127.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebf6fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#d6eafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#a1cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -463.38,
    y1: 588.04,
    x2: -362.01,
    y2: 588.04,
    gradientTransform: "matrix(-0.41, 0.15, 0.13, 0.34, 72.92, 34.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -498.04,
    y1: 317.52,
    x2: -443.54,
    y2: 337.41,
    gradientTransform: "matrix(-0.66, 0.18, 0.24, 0.91, 566.12, 5)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -196.02,
    y1: 207.67,
    x2: -140.41,
    y2: 207.67,
    gradientTransform: "matrix(-1, 0, 0, 1, 679.22, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2e3242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23486f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -186.36,
    cy: 223.18,
    r: 17.05,
    gradientTransform: "matrix(-0.94, 0, 0, 0.95, 671.88, 39.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c69c6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -141.38,
    y1: 313.65,
    x2: -141.38,
    y2: 313.65,
    gradientTransform: "matrix(-1, 0, 0, 1, 679.22, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -114.47,
    y1: 311.85,
    x2: -114.47,
    y2: 311.85,
    gradientTransform: "matrix(-1, 0, 0, 1, 679.22, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -283.46,
    y1: 274.67,
    x2: -230.65,
    y2: 366.15,
    gradientTransform: "matrix(-0.83, 0, 0, 1, 631.31, 0.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 874.16,
    y1: 246.25,
    x2: 810.24,
    y2: 380.33,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -98.33,
    y1: 303.34,
    x2: -85.26,
    y2: 325.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 785.3,
    y1: 289.84,
    x2: 756.67,
    y2: 339.45,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -186.94,
    y1: 190.65,
    x2: -136.32,
    y2: 190.65,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 57.09,
    cy: 271.04,
    r: 6.33,
    gradientTransform: "matrix(-1.43, 0, 0, 1.36, 525.19, -210.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe28e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deb87d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 12.15,
    cy: 366.44,
    r: 11.98,
    gradientTransform: "matrix(-1.09, 0.17, 0.19, 1.22, 655.79, -148)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 215.87,
    y1: -38.69,
    x2: 237.82,
    y2: -0.67,
    gradientTransform: "matrix(-0.03, -1, -1, 0.03, 521.77, 390.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 881.6,
    y1: 309.22,
    x2: 813.23,
    y2: 272.43,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 303.37,
    y1: -53.08,
    x2: 336.22,
    y2: 3.82,
    gradientTransform: "matrix(-0.07, -1, -1, 0.07, 482.13, 501.86)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 838.85,
    y1: 325.16,
    x2: 758.07,
    y2: 285.82,
    xlinkHref: "#linear-gradient-2"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 472.93,
    y: 127.43,
    width: 291.51,
    height: 418.69,
    rx: 57.7,
    transform: "translate(924.58 546.12) rotate(180)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 486.21,
    y: 136.52,
    width: 281.91,
    height: 404.64,
    rx: 48.07,
    transform: "translate(941.56 550.26) rotate(180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 544.25,
    y: 289.44,
    width: 179.04,
    height: 14.22,
    rx: 7.11,
    transform: "translate(954.76 465.66) rotate(-180)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 544.25,
    y: 337.88,
    width: 179.04,
    height: 14.22,
    rx: 7.11,
    transform: "translate(954.76 562.54) rotate(-180)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 544.25,
    y: 369.98,
    width: 179.04,
    height: 14.22,
    rx: 7.11,
    transform: "translate(954.76 626.75) rotate(180)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "481.05 203.4 468.94 193.4 510.55 135.68 522.66 145.68 481.05 203.4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M793.87,331.15c-4.11-3.32-8.26-6.68-12.36-10.07l-.15-.12.1-.31a85.4,85.4,0,0,1,3.23-8.64q1.78-4.2,3.82-8.21c2.7-5.36,5.65-10.54,8.79-15.59,1.58-2.51,3.18-5,4.86-7.46q1.25-1.85,2.53-3.66c.86-1.2,1.7-2.43,2.65-3.57a33.92,33.92,0,0,1,6.58-6.22,30.51,30.51,0,0,1,4.14-2.5,23.11,23.11,0,0,1,5-1.87l.42-.1,0,0,12.11,10,.05.44a23.14,23.14,0,0,1,2.72,7.85,18.73,18.73,0,0,1,0,6.31,15.73,15.73,0,0,1-1.84,5.09,17.36,17.36,0,0,1-1.45,2.1l-1.55,2a157.48,157.48,0,0,1-13.22,14.86,132.54,132.54,0,0,1-13.72,11.92C802.09,326.75,797.79,329.62,793.87,331.15Zm-.08-.64c3-8.09,5.65-14.84,8.08-21.16s4.71-11.84,7.07-16.94a113.9,113.9,0,0,1,7.59-14l1.05-1.6a9,9,0,0,1,1.15-1.51,8.72,8.72,0,0,1,3.35-2.12,16.56,16.56,0,0,1,5.17-.9,34.81,34.81,0,0,1,7.92.63l.06.44-12.11-10,.46-.06a23.25,23.25,0,0,1-.19,5.34,31.28,31.28,0,0,1-1.06,4.72,34.27,34.27,0,0,1-3.82,8.21c-.79,1.26-1.69,2.44-2.56,3.64s-1.77,2.38-2.67,3.56c-1.78,2.37-3.65,4.67-5.54,7-3.79,4.58-7.77,9-12,13.28q-3.16,3.19-6.58,6.22A85.46,85.46,0,0,1,782,321l-.06-.43C785.9,323.86,789.83,327.16,793.79,330.51Z",
    transform: "translate(-312.78 -127.43)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "345.19 179.82 630.42 113.03 619.88 78.34 334.66 145.13 345.19 179.82"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "298.37 174.53 347.17 180.7 334.65 145.23 298.37 174.53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M943.91,241l31.89-7.27a.48.48,0,0,0,.33-.63l-10.39-34.93a.58.58,0,0,0-.65-.41L933.21,205a.49.49,0,0,0-.34.63l10.4,34.93A.56.56,0,0,0,943.91,241Z",
    transform: "translate(-312.78 -127.43)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M474.77,537.5c9.43,57.27,160.43,85.41,263.73,87,150.28,2.26,287.07-50.43,283.55-71.74-3.19-19.27-116.23,17.25-277.61-31.21-106.46-32-164-79.9-221-52.59C496.33,481.88,470.45,511.25,474.77,537.5Z",
    transform: "translate(-312.78 -127.43)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "552.26 426.65 530.87 427.79 522.66 251.01 544.04 249.87 552.26 426.65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M865.31,554.33c-7.18.45-14.43.88-21.64,1.26l-.32,0-.08-.37c-1.49-7.31-2.73-14.64-3.84-22s-2.11-14.66-3-22c-1.79-14.69-3.2-29.38-4.35-44.09s-2-29.44-2.58-44.18a173.8,173.8,0,0,1,.94-22.19c.41-3.71,1-7.42,1.69-11.15a81.24,81.24,0,0,1,2.92-11.21l.13-.37.22,0,21.39-1.13h0l.38.35a43.25,43.25,0,0,1,8.42,11.06A56.58,56.58,0,0,1,870.4,400a64.57,64.57,0,0,1,2.27,11.81c.2,2,.29,3.93.34,5.89l.19,5.87c.42,15.66.38,31.27-.13,46.52s-1.43,30.14-2.73,44.33c-.33,3.54-.65,7.06-1,10.5l-.56,5.15-.6,5.06C867.3,541.77,866.45,548.29,865.31,554.33Zm-.55-.5c-1.82-8.68-3.36-16.89-4.88-25l-1.12-6L857.69,517c-.73-3.93-1.39-7.78-2.07-11.6-2.66-15.28-5-29.85-6.83-44.07s-3.29-28.06-4.24-41.87l-.32-5.18c-.12-1.72-.21-3.45-.18-5.16a47.6,47.6,0,0,1,1.25-10.28,49.88,49.88,0,0,1,11.15-21.52l.39.35-21.39,1.14.36-.39a80.56,80.56,0,0,1,3.94,10.89c1.07,3.64,2,7.29,2.72,10.95a173.73,173.73,0,0,1,3,22c.83,14.73,1.31,29.47,1.53,44.22s.18,29.52-.24,44.31q-.3,11.08-.94,22.19c-.42,7.4-1,14.8-1.79,22.22l-.39-.35C850.67,554.47,857.69,554.15,864.76,553.83Z",
    transform: "translate(-312.78 -127.43)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M819.63,203.64c.23,15.44,11.7,33.27,27.64,33.34,16.59.08,29.31-19.13,27.86-34.54a28.76,28.76,0,0,0-8.08-16.88c-5.75-5.76-12.13-6.2-21.52-6.84-8.59-.58-12.88-.87-17.16,2.42C819.58,187.9,819.62,202.91,819.63,203.64Z",
    transform: "translate(-312.78 -127.43)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M830.3,267.16l34.27-.35a30.19,30.19,0,0,1-7.45-9.75,24.09,24.09,0,0,1-2.17-6.42,41.59,41.59,0,0,1-.5-6c-.08-1.72-.09-3.45-.1-4.49,0-1.31,0-2.41,0-3.21H839.42c.06.79.14,1.89.2,3.21.07,1.58.14,3.1.1,4.7a32.54,32.54,0,0,1-.6,5.54,29.53,29.53,0,0,1-2.81,7.3A57.86,57.86,0,0,1,830.3,267.16Z",
    transform: "translate(-312.78 -127.43)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M820.6,313.65",
    transform: "translate(-312.78 -127.43)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M793.69,311.85",
    transform: "translate(-312.78 -127.43)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "473.32 414.01 494.28 418.69 528.08 245.42 507.11 240.74 473.32 414.01"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M786.33,541.28l20.79,4.56-.34.23c1.14-14.77,2.88-29.42,4.88-44s4.27-29.14,6.74-43.65,5.13-29,8.06-43.39c1.56-7.19,3.42-14.32,5.7-21.37q1.68-5.29,3.74-10.51a102.13,102.13,0,0,1,4.67-10.33l.22.33-21-4.68.34-.23A49.68,49.68,0,0,1,824,379.93a59.92,59.92,0,0,1,1.16,10.87,65,65,0,0,1-.71,10.46c-.53,3.45-1.33,6.87-2,10.3-2.9,13.73-6.16,27.44-9.81,41.36s-7.65,28.07-12,42.69S791.6,525.27,786.33,541.28Zm-.47.31c.36-12.86,1.41-26.73,2.65-41s2.91-29,4.88-43.95,4.35-30.12,7.08-45.27c.71-3.79,1.31-7.58,2.2-11.36a80.55,80.55,0,0,1,3.51-11.2,69,69,0,0,1,5.38-10.78,46.29,46.29,0,0,1,8.05-9.95l.27-.24H820l21,4.68.19.05,0,.28a103.07,103.07,0,0,1,.45,11.33q-.06,5.61-.48,11.15c-.54,7.39-1.49,14.7-2.75,21.95q-4.07,21.69-8.84,43.24t-10.16,43c-3.64,14.28-7.53,28.51-12,42.62l-.09.28-.25-.05Z",
    transform: "translate(-312.78 -127.43)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "543.45 276.12 503.83 272.4 508 217.96 547.61 221.68 543.45 276.12"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M862.55,411c-3.73.09-7.47.25-11.27.44l-11.6.62c-2,.11-4,.14-5.94.38s-4,.64-6,1a32.13,32.13,0,0,1-6.2.65,24.55,24.55,0,0,1-6.2-.88l-14.93-4,2.76-10.43a72.25,72.25,0,0,1,5.13-13.3c2.14-4.4,4.65-8.77,6.71-13.17A53.2,53.2,0,0,0,819.47,359a57.44,57.44,0,0,0,.78-6.78l.5-6.81v0h0c3.3.29,6.6.63,9.91.87l9.92.78c3.3.24,6.6.54,9.9.86a59.32,59.32,0,0,0,10,.18l.87-.06.09,1.2a71.83,71.83,0,0,0,3.09,14.95l2.61,8.6c.87,3,1.7,6.13,2.44,9.36a79.94,79.94,0,0,1,2,19.41c-.05,1.56-.13,3.11-.26,4.63a13.4,13.4,0,0,1-.75,4.22,3.59,3.59,0,0,1-2.67,2.14,5.94,5.94,0,0,1-2.23-.1l-.68-.2c-.24-.08-.51-.19-.76-.29A12.41,12.41,0,0,1,862.55,411Zm-12.64-15-1.56-2.57-1.3-2.19c-.78-1.33-1.4-2.46-2-3.5a30.5,30.5,0,0,1-2.15-4.67,6.28,6.28,0,0,1-.23-2.58,18.64,18.64,0,0,1,.27-2.17,17.19,17.19,0,0,1,4.07-7.82c1.09-1.3,2.26-2.71,3.48-4.24.6-.77,1.25-1.56,1.87-2.39s1.22-1.71,1.78-2.62A40.42,40.42,0,0,0,859.33,349l1,1.14a59.26,59.26,0,0,0-9.83-1.68c-3.31-.3-6.61-.62-9.9-1l-9.89-1.08c-3.29-.37-6.6-.66-9.9-1l0,0-.54,6.81A55.32,55.32,0,0,0,820,359a53.63,53.63,0,0,0,2.36,13.87c1.37,4.67,3.19,9.37,4.64,14a72.81,72.81,0,0,1,3,13.93l-12.17-14.44a8.74,8.74,0,0,1,3.71.05,15.66,15.66,0,0,1,3.7,1.57A41.87,41.87,0,0,0,829.2,390c1.32.54,2.63.88,4,1.3,2.67.84,5.4,1.66,8.2,2.48S847,395.34,849.91,396.05Z",
    transform: "translate(-312.78 -127.43)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M852.45,265.81c-3,5.25-8.16,8.43-13.33,8.08a12.62,12.62,0,0,1-6.6-2.53,12.18,12.18,0,0,0-5.47,4.09,13.27,13.27,0,0,0-2.16,8.16c.27,17-7.27,63.25-7.52,64.79-.46,2.77-1.23,7.21-2.42,12.68a.9.9,0,0,0,.2.5.66.66,0,0,0,.47.2l48.67-.27a.68.68,0,0,0,.66-.7c-.07-6.61-.42-16.21-1.29-18.82-2.56-7.63-4.71-22.41-3.11-53.69-.46-1.75-1.12-4.42-1.75-7.76-.54-2.81-.61-3.74-.9-5A20.83,20.83,0,0,0,852.45,265.81Z",
    transform: "translate(-312.78 -127.43)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M853.56,275.3a7.56,7.56,0,0,0,4.62-1.52,7.31,7.31,0,0,0,1.6-1.66l.06-.09,0,0,0,.06-.08.12-.15.23c-.42.61-.86,1.22-1.33,1.81a26.62,26.62,0,0,1-3.13,3.35,25,25,0,0,1-8.36,5,22,22,0,0,1-10.66,1,23.25,23.25,0,0,1-9.72-3.94l10,1.3c-.62.36-.74.69-.62.74s.26,0,.45.35c.1.18.23.41.41.79a2.21,2.21,0,0,1,.14.42c0,.21.1.55.14.81l.28,1.71.27,1.71c.07.54.14,1.08.2,1.62.13,1.07.23,2.16.28,3.22a31.7,31.7,0,0,1-.34,6.18c-.32,2-.8,4-1.31,6a102.48,102.48,0,0,1-3.75,11.6c-2.86,7.63-6.64,15-9.86,22.46-.82,1.85-1.56,3.72-2.3,5.58s-1.36,3.75-2.05,5.62A93.32,93.32,0,0,0,815,361.09v0a.66.66,0,0,0,.51.67c.31,0,.64,0,1,0h1.93l3.87,0,7.73,0,15.47-.08,15.47-.09h2.89c.31,0,.69.07.92-.2s.19-.61.19-.92l0-1,0-1.94c-.06-2.57-.15-5.15-.3-7.72-.08-1.29-.17-2.58-.29-3.86-.07-.64-.14-1.28-.23-1.92-.06-.32-.09-.64-.16-.95a1.59,1.59,0,0,0-.14-.47,1.34,1.34,0,0,0-.49-.35,2,2,0,0,1-.54-.32,2.61,2.61,0,0,1-.31-.43c-.18-.28-.38-.57-.56-.87-.34-.58-.72-1.18-1-1.78-.67-1.21-1.33-2.44-2-3.69-1.24-2.5-2.45-5.05-3.56-7.65s-2.18-5.22-3.18-7.86c-2-5.29-3.86-10.66-5.35-16a126.69,126.69,0,0,1-3.33-16.16l.54,5.25q-1.37-3.26-2.58-6.6c-.41-1.12-.81-2.22-1.14-3.38-.17-.58-.34-1.18-.49-1.74a7,7,0,0,0-.37-1.15c-.08-.11-.09,0,0,0a.33.33,0,0,0,.24,0,3.21,3.21,0,0,0,1.2-.74,11.23,11.23,0,0,0,.89-.91c.18-.19.31-.38.5-.61a8.11,8.11,0,0,0,.54-.73c.41-.54.78-1.13,1.25-1.88l.36-.57.17-.29a10.13,10.13,0,0,0,1.53,1,9.44,9.44,0,0,0,4,1A6.85,6.85,0,0,0,853.56,275.3Zm-2.21-19a9.47,9.47,0,0,1,4.06-.23,12.67,12.67,0,0,1,4.49,1.61,13.58,13.58,0,0,1,1.78,1.27h1.26a12.58,12.58,0,0,1,3.14.5c.49.15.95.31,1.43.5s.9.42,1.35.66a13.06,13.06,0,0,1,2.45,1.7,15.79,15.79,0,0,1,3.69,4.8,17.23,17.23,0,0,1,1.15,2.89,18.25,18.25,0,0,1,.61,3c.09.88.11,1.4.13,1.84l0,1.27c0,.83.07,1.7.11,2.56.09,1.73.12,3.48.11,5.26l.54,5.25c-1.25,4.92-2.74,9.83-4.37,14.76s-3.38,9.88-4.9,14.89a99.31,99.31,0,0,0-3.58,15.23c-.17,1.29-.32,2.58-.38,3.88-.05.65-.05,1.3-.07,1.95,0,.34,0,.66,0,1a1.54,1.54,0,0,1-.28,1.09,1.78,1.78,0,0,0-.23.59,1.29,1.29,0,0,0,.06.48c.07.31.1.63.16.95.09.64.16,1.28.23,1.92.12,1.28.21,2.57.29,3.86.15,2.57.24,5.15.3,7.72l0,1.94,0,1c0,.31.06.68-.19.92s-.61.19-.92.2H861l-15.47.09L830,361.7l-7.73,0-3.87,0-1.93,0c-.32,0-.64,0-1,0a.75.75,0,0,1-.62-.71h0a93.22,93.22,0,0,0,1.1-11.69,92.28,92.28,0,0,0-.66-11.92c-.87-8-2.46-16.08-3.36-23.95-.49-3.94-.82-7.84-1-11.67-.06-.95-.09-1.92-.12-2.86s-.08-1.89-.05-2.82a32.47,32.47,0,0,1,.58-5.5c.17-.89.35-1.74.58-2.62l.65-2.53.3-1.22a6.36,6.36,0,0,0,.15-.65l.14-1a33.35,33.35,0,0,1,1-5,24.18,24.18,0,0,1,5.51-10.06,22.93,22.93,0,0,1,9-5.78l6.5-2.34,3.51,3.64a4.88,4.88,0,0,0,1,.8,1.43,1.43,0,0,0,1,.14,4.08,4.08,0,0,0,1.76-.87,6.14,6.14,0,0,0,1-.9,6.23,6.23,0,0,0,.44-.55l.05-.07,0,0v0l.1-.14a11.8,11.8,0,0,1,2-2.28A12.22,12.22,0,0,1,851.35,256.32Z",
    transform: "translate(-312.78 -127.43)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "426.97 184.27 428.47 176.56 489.51 190.19 488 197.9 426.97 184.27"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M739.48,311.88c.45-2.63.93-5.31,1.45-7.95l0-.2.35-.05a71.4,71.4,0,0,1,8.16-.67c2.69-.08,5.35-.06,8,.05a148,148,0,0,1,15.69,1.46,153.65,153.65,0,0,1,15.36,3,26.15,26.15,0,0,1,7.25,3.37,23.2,23.2,0,0,1,6.57,6.44l.25.36v0l-1.5,7.7-.39.25c-.47.62-1,1.33-1.44,1.87s-.95,1.05-1.42,1.53l-1.37,1.23c-.23.19-.47.42-.7.59l-.67.5a17.62,17.62,0,0,1-5.26,2.58,12.74,12.74,0,0,1-4.84.44,13.73,13.73,0,0,1-2.23-.43l-2.17-.57a124.85,124.85,0,0,1-16.68-5.72,100.42,100.42,0,0,1-14.29-7.41C745.5,317.56,741.8,314.85,739.48,311.88Zm.53-.36c7.85-.7,14.33-1.14,20.36-1.56s11.29-.63,16.22-.59a89.3,89.3,0,0,1,13.85,1.09l1.63.29a7.23,7.23,0,0,1,1.6.41,7,7,0,0,1,2.78,2.15,16.84,16.84,0,0,1,2.38,4.29l.27.71c.09.24.17.54.26.81l.53,1.65.5,2c.17.68.3,1.53.46,2.3l-.38.25,1.5-7.71.24.38a23.24,23.24,0,0,1-8.68,3,26.46,26.46,0,0,1-8,0,153.14,153.14,0,0,1-15.17-3.85,142.71,142.71,0,0,1-14.82-5.35q-3.66-1.53-7.26-3.36a70.39,70.39,0,0,1-7.1-4.07l.38-.26C741.08,306.55,740.56,309,740,311.52Z",
    transform: "translate(-312.78 -127.43)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M819,215.37c.18,6.63.51,18.74,8.92,25.48a20.14,20.14,0,0,0,10.71,4.23,21.15,21.15,0,0,0,14.28-4.14,22.81,22.81,0,0,0,6.06-6.95c2-3.52,2.13-5.93,3.66-15.22,1.92-11.69,2.24-11.2,2-12.49-1.66-8.72-12.91-14.34-21.77-15.34-3-.34-14.07-1.6-20.25,6.18C818.59,202.11,818.76,208.15,819,215.37Z",
    transform: "translate(-312.78 -127.43)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M815.59,189.09c-.59,4.76,4.62,9,5.23,9.44,3.52,2.76,6.38,2.38,19.94,1.79,11-.48,13.52-.42,17.44-2.61,1.09-.6,8.44-4.8,7.93-9-.33-2.83-4-4.45-7.35-5.69-5.24-1.94-11-2.09-19.6-2.3-7.82-.2-11.73-.3-15.62.81C821.25,182.16,816.15,184.68,815.59,189.09Z",
    transform: "translate(-312.78 -127.43)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M771.05,567.83c-4.86,4.91-7.29,7.37-6.45,9.37,2,4.76,19.76,5.72,31.54-1.57,2.9-1.81,8-5,7.5-9.54-.52-4.82-7-9.37-12.59-10.18C783.88,554.87,778.7,560.1,771.05,567.83Z",
    transform: "translate(-312.78 -127.43)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M873.6,578.94c-3,5.77-9.25,7.24-14.18,8.41-5.37,1.27-18,2.88-20-2.83s7.64-14.73,12.7-18.47c3.12-2.3,10.46-7.73,16.66-5.13a10.31,10.31,0,0,1,4.9,4.65A14.57,14.57,0,0,1,873.6,578.94Z",
    transform: "translate(-312.78 -127.43)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 443.35,
    cy: 156.41,
    r: 8.82
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M707.15,304.36c13,2.05,16.51,4.67,19.87,1.87,3-2.47,4.71-8.28,3-11.18-4.53-7.82-34.22,4.41-33.65,7.63C696.56,303.55,698.79,303,707.15,304.36Z",
    transform: "translate(-312.78 -127.43)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "501.26 179.12 511.61 190.92 568.06 147.61 557.71 135.81 501.26 179.12"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M814.35,306.58c3.46,3.86,6.88,7.68,10.28,11.56l-.44,0a82.29,82.29,0,0,1,5.58-7.34q2.91-3.51,6-6.77c4.13-4.36,8.44-8.47,12.91-12.39,2.23-2,4.48-3.9,6.79-5.76,1.15-.93,2.31-1.86,3.48-2.77s2.33-1.84,3.56-2.66a34.28,34.28,0,0,1,8.09-4.07,32.17,32.17,0,0,1,4.69-1.2,23.27,23.27,0,0,1,5.33-.35l0,.47-10.35-11.81.44,0a35.32,35.32,0,0,1,.87,7.9,16.52,16.52,0,0,1-.75,5.19,8.57,8.57,0,0,1-2,3.42,9.52,9.52,0,0,1-1.48,1.19l-1.56,1.1a113.54,113.54,0,0,1-13.76,8c-5,2.52-10.54,5-16.72,7.58S822.35,303.32,814.35,306.58Zm-.64-.07c1.41-4,4.16-8.35,7.32-12.94a132.07,132.07,0,0,1,11.51-14.08A157.28,157.28,0,0,1,847,265.83l2-1.6a16.34,16.34,0,0,1,2.06-1.52,15.85,15.85,0,0,1,5-2,18.67,18.67,0,0,1,6.31-.22,23.63,23.63,0,0,1,7.93,2.48l.43,0,10.36,11.81,0,.05-.09.42a23.29,23.29,0,0,1-1.72,5.06,32.17,32.17,0,0,1-2.38,4.21,33.74,33.74,0,0,1-6,6.76c-1.11,1-2.31,1.85-3.49,2.75s-2.38,1.77-3.58,2.65c-2.39,1.75-4.85,3.42-7.32,5.07-4.94,3.29-10,6.4-15.31,9.26q-4,2.15-8.09,4.06a86.19,86.19,0,0,1-8.54,3.49l-.31.1-.13-.14C820.64,314.57,817.15,310.53,813.71,306.51Z",
    transform: "translate(-312.78 -127.43)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "455.39 165.23 452.17 171.97 512.99 197.01 516.22 190.27 455.39 165.23"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M768.28,292.94c-1,2.23-2,4.41-3.06,6.59l-.16-.42a80.41,80.41,0,0,1,8.49,1c2.78.45,5.52,1,8.23,1.63q8.12,1.86,15.93,4.49c5.21,1.75,10.36,3.64,15.37,5.87a29.8,29.8,0,0,1,7,4.65,24.94,24.94,0,0,1,5.83,7.43l-.4.15,3.23-6.74.16.42c-.57.5-1.18,1.08-1.71,1.52l-1.55,1.23-1.41,1c-.23.16-.47.34-.69.48l-.65.38a16.94,16.94,0,0,1-4.57,1.94,8,8,0,0,1-3.71,0,8.3,8.3,0,0,1-1.66-.62l-1.61-.74a102.63,102.63,0,0,1-12.86-7.3c-4.36-2.86-8.85-6.15-13.77-9.92S774.47,298,768.28,292.94Zm-.22-.57c4-.9,8.81-.81,14-.47a116.83,116.83,0,0,1,16.64,2.6,143.3,143.3,0,0,1,17.56,5.22l2.18.83a15.07,15.07,0,0,1,2.15.94,14.09,14.09,0,0,1,3.89,3.15,18.16,18.16,0,0,1,3,5.06l.3.78c.1.26.18.58.26.87l.49,1.75c.13.65.24,1.35.35,2s.14,1.54.19,2.3l.17.42-3.23,6.74v0l-.39.12a24.85,24.85,0,0,1-9.37,1.18,30,30,0,0,1-8.23-1.61c-5.13-2-10.12-4.24-15-6.66s-9.75-5.1-14.48-8c-2.36-1.46-4.69-3-7-4.64a80.31,80.31,0,0,1-6.72-5.29l-.25-.22.09-.2C765.77,297,766.92,294.64,768.06,292.37Z",
    transform: "translate(-312.78 -127.43)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 544.25,
    y: 402.09,
    width: 179.04,
    height: 14.22,
    rx: 7.11,
    transform: "translate(954.76 690.97) rotate(-180)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_07",
    "data-name": "icon 07"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 326.39,
    cy: 82.67,
    rx: 20.26,
    ry: 20.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M659.43,256.51a20.27,20.27,0,1,0-40.52,0",
    transform: "translate(-312.78 -127.43)"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 202,
    height: 446,
    transform: "translate(0 27.57) scale(0.79 0.79)",
    xlinkHref: "data:image/png;base64,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"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistroCenfotec);
export default __webpack_public_path__ + "static/media/RegistroCenfotec.cf78635730376d2bf6331b72b7da3e83.svg";
export { ForwardRef as ReactComponent };